export default __webpack_public_path__ + "static/media/2.7b0e1167.jpg";